"use client";

import { memo } from "react";
import { sanitizeFieldLabel } from "@/features/forms/_logic/sanitize-field-label";

/**
 * Renders a form field label (which may contain basic inline HTML formatting)
 * with sanitized `dangerouslySetInnerHTML`, so labels display consistently —
 * bold/italic/links rendered, not shown as literal markup — everywhere a field
 * label appears (the live form and the already-submitted recap alike).
 *
 * @param props.html - The label's raw HTML content.
 * @param props.className - Optional wrapper class.
 * @returns Sanitized label element.
 */
export const HtmlLabel = memo(
  ({ html, className }: { html: string; className?: string }): JSX.Element => (
    <span className={className} dangerouslySetInnerHTML={{ __html: sanitizeFieldLabel(html) }} />
  )
);
HtmlLabel.displayName = "HtmlLabel";
